var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYesnoblockicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 22,
    viewBox: "0 0 54 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11125 15.198L3.59375 10.6805L2.05542 12.208L8.11125 18.2638L21.1113 5.26383L19.5838 3.73633L8.11125 15.198Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59376 10.6807L8.11127 15.1982L19.5838 3.73657L21.1113 5.26407L8.11127 18.2641L2.05543 12.2082L3.59376 10.6807ZM8.11153 14.0671L19.584 2.60547L22.2426 5.26407L8.11127 19.3954L0.922058 12.2062L3.59576 9.55136L8.11153 14.0671Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7259 1.25L26.1395 20.75H23.5001L30.0864 1.25H32.7259Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8405 0.450195L26.7137 21.5502H22.3854L29.5122 0.450195H33.8405ZM32.7259 1.2502H30.0864L23.5 20.7502H26.1395L32.7259 1.2502Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.785 4.94449L51.2575 3.41699L45.2016 9.47283L39.1458 3.41699L37.6183 4.94449L43.6741 11.0003L37.6183 17.0562L39.1458 18.5837L45.2016 12.5278L51.2575 18.5837L52.785 17.0562L46.7291 11.0003L52.785 4.94449Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9163 4.94403L47.8605 10.9999L53.9163 17.0557L51.2574 19.7146L45.2016 13.6587L39.1457 19.7146L36.4869 17.0557L42.5427 10.9999L36.4869 4.94403L39.1457 2.28516L45.2016 8.34099L51.2574 2.28516L53.9163 4.94403ZM45.2016 9.47236L39.1457 3.41653L37.6182 4.94403L43.6741 10.9999L37.6182 17.0557L39.1457 18.5832L45.2016 12.5274L51.2574 18.5832L52.7849 17.0557L46.7291 10.9999L52.7849 4.94403L51.2574 3.41653L45.2016 9.47236Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesnoblockicon);
export default __webpack_public_path__ + "static/media/yesnoblockicon.3e568e89ebc5774ffe346ae17810cca6.svg";
export { ForwardRef as ReactComponent };